import classNames from 'classnames';
import is from 'is-it-check';
import PropTypes from 'prop-types';
import React, { useContext, useEffect, useRef, useState } from 'react';
import { Collapse, Nav, Navbar } from 'reactstrap';
import bgNavbarImg from '../../assets/img/generic/bg-navbar.png';
import { navbarBreakPoint, topNavbarBreakpoint } from '../../config';
import AppContext from '../../context/Context';
import { VendorsContext } from '../../context/VendorsContext';
import { DashboardContext } from '../../context/DashboardContext';
import routes from '../../routes';
import Flex from '../common/Flex';
import Logo from './Logo';
import NavbarTopDropDownMenus from './NavbarTopDropDownMenus';
import NavbarVerticalMenu from './NavbarVerticalMenu';
import ToggleButton from './ToggleButton';
import BZAPIService from '../../services/BZAPIService';
import { adminCanView } from '../../helpers/rbac';
const NavbarVertical = ({ navbarStyle }) => {
  const navBarRef = useRef(null);
  const [isLoaded, setIsLoaded] = useState(false);
  // eslint-disable-next-line
  const [vendors, setVendors] = useContext(VendorsContext);
  // eslint-disable-next-line
  const [dashboard, setDashboard] = useContext(DashboardContext);

  const {
    showBurgerMenu,
    isNavbarVerticalCollapsed,
    setIsNavbarVerticalCollapsed,
    isCombo,
    setShowBurgerMenu,
    setNavbarCollapsed
  } = useContext(AppContext);

  const HTMLClassList = document.getElementsByTagName('html')[0].classList;
  //Control Component did mount and unmounted of hover effect
  if (isNavbarVerticalCollapsed) {
    HTMLClassList.add('navbar-vertical-collapsed');
  }

  async function onLoad() {
    // Load Routes
    const dashboardPromise = BZAPIService.getDashboard();
    const vendorsPromise = BZAPIService.getVendors();
    const myUserPermissionsPromise = BZAPIService.getMyUserPermissions();
    const [dashboard, vendors, myUserPermissions] = await Promise.all([
      dashboardPromise,
      vendorsPromise,
      myUserPermissionsPromise
    ]);
    setDashboard(dashboard);
    setVendors(vendors);
    if (!adminCanView(myUserPermissions)) {
      routes.splice(routes.findIndex(el => el.name === 'Admin Settings'), 1);
      routes.splice(routes.findIndex(el => el.name === 'Integrations'), 1);
    }
    // rendering the navbar with 'vendor' type vendors only
    const vendorRoutes = vendors
      ?.filter(v => v?.type === 'vendor')
      ?.filter(vendor => vendor.active)
      ?.map(vendor => {
        const vendorRoute = {
          to: `/vendors/${vendor.id}`,
          name: vendor?.name?.replace('Systems', 'Networks').replace('Microsoft', ''),
          exact: true,
          children: [
            {
              to: `/vendors/${vendor.id}/products`,
              name: `Products`
              // exact: true
            },
            {
              to: `/vendors/${vendor.id}/configuration`,
              name: `Configuration`
              // exact: true
            }
            // {
            //   to: `${
            //     vendor.id === 'postgre'
            //       ? '/documentation/vendor-configuration-guides/'
            //       : vendor.id === 'msftaccess'
            //       ? '/documentation/vendor-configuration-guides/microsoft-access-integration-guide'
            //       : vendor.id === 'msftsql'
            //       ? '/documentation/vendor-configuration-guides/microsoft-sql-integration-guide'
            //       : vendor.id === 'msftserver'
            //       ? '/documentation/vendor-configuration-guides/microsoft-server-integration-guide'
            //       : vendor.id === 'msft'
            //       ? `/documentation/vendor-configuration-guides/microsoft-integration-guide`
            //       : vendor.id === 'msft365'
            //       ? `/documentation/vendor-configuration-guides/microsoft365-integration-guide`
            //       : vendor.id === 'rh'
            //       ? `/documentation/vendor-configuration-guides/red-hat-integration-guide`
            //       : `/documentation/vendor-configuration-guides/${vendor.id}-integration-guide`
            //   }`,
            //   name: `Documentation`
            //   // exact: true
            // }
          ]
        };

        return vendorRoute;
      });
    const vendorIndex = routes.findIndex(el => el.name === 'Vendors');
    if (vendorRoutes.length) {
      // add vendor routes
      routes[vendorIndex].children = vendorRoutes;
    } else {
      // If no vendors remove it from nav
      console.log('no vendors');
      routes.splice(vendorIndex, 1);
    }
    setIsLoaded(true);
  }

  useEffect(() => {
    if (!vendors?.length && !dashboard?.services) {
      onLoad();
    }
  }, []);

  // Track context changes

  useEffect(() => {
    if (is.windows()) {
      HTMLClassList.add('windows');
    }
    if (is.chrome()) {
      HTMLClassList.add('chrome');
    }
    if (is.firefox()) {
      HTMLClassList.add('firefox');
    }

    return () => {
      HTMLClassList.remove('navbar-vertical-collapsed-hover');
    };
    // eslint-disable-next-line
  }, [isNavbarVerticalCollapsed, HTMLClassList]);

  //Control mouseEnter event
  let time = null;
  const handleMouseEnter = () => {
    if (isNavbarVerticalCollapsed) {
      time = setTimeout(() => {
        HTMLClassList.add('navbar-vertical-collapsed-hover');
      }, 100);
    }
  };
  return (
    <Navbar
      container={false}
      expand={navbarBreakPoint}
      className={classNames('navbar-vertical navbar-glass', {
        [`navbar-${navbarStyle}`]: navbarStyle !== 'transparent'
      })}
      light
    >
      <Flex align="center">
        <ToggleButton
          isNavbarVerticalCollapsed={isNavbarVerticalCollapsed}
          setIsNavbarVerticalCollapsed={setIsNavbarVerticalCollapsed}
        />
        <Logo at="navbar-vertical" width={40} />
      </Flex>

      <Collapse
        navbar
        isOpen={showBurgerMenu}
        className="scrollbar"
        innerRef={navBarRef}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={() => {
          clearTimeout(time);
          HTMLClassList.remove('navbar-vertical-collapsed-hover');
        }}
        style={
          navbarStyle === 'vibrant' && {
            backgroundImage: `linear-gradient(-45deg, rgba(0, 160, 255, 0.86), #0048a2),url(${bgNavbarImg})`
          }
        }
      >
        <Nav navbar vertical>
          {isLoaded ? <NavbarVerticalMenu routes={routes} /> : null}
        </Nav>
        <div className="settings px-3 px-xl-0">
          {isCombo && (
            <div className={`d-${topNavbarBreakpoint}-none`}>
              {/* <div className="navbar-vertical-divider">
                <hr className="navbar-vertical-hr my-2" />
              </div> */}
              <Nav navbar>
                <NavbarTopDropDownMenus setNavbarCollapsed={setNavbarCollapsed} setShowBurgerMenu={setShowBurgerMenu} />
              </Nav>
            </div>
          )}
        </div>
      </Collapse>
    </Navbar>
  );
};

NavbarVertical.propTypes = {
  navbarStyle: PropTypes.string
};

// NavbarVertical.defaultProps = {
//   navbarStyle: 'transparent'
// };

export default NavbarVertical;
